module.exports = __webpack_public_path__ + "static/media/09_720.9c859b45.jpeg";